import { SimpleDefinitionListItem } from '@components'
import { Switch } from '@heroui/react'

import { 
  BellAlertIcon, 
  CalendarDaysIcon, 
  DocumentIcon, 
  SignalIcon, 
  UserGroupIcon 
} from '@heroicons/react/24/outline'

import PropTypes from 'prop-types'

const NotificationDetails = ({ handleUpdateNotification, notification }) => (
  <div>
    <div>
      <h2 className='text-lg font-semibold'>Details</h2>
      <SimpleDefinitionListItem caption="Title" description={notification.title} icon={<DocumentIcon />} />
      <SimpleDefinitionListItem caption="Alert Type" description={notification.status.name} icon={<BellAlertIcon />} />
      <SimpleDefinitionListItem caption="No of Recipients" description={notification.no_of_recipients} icon={<UserGroupIcon />} />
      <SimpleDefinitionListItem caption="Notification Type" description={notification.type.name} icon={<UserGroupIcon />} />
      <SimpleDefinitionListItem caption="Created" description={notification.created_at} icon={<CalendarDaysIcon />} />
    </div>
    
    {notification.type.is_app && (
      <div className="mt-6">
        <h2 className='text-lg font-semibold'>Actions</h2>

        <SimpleDefinitionListItem 
          caption="Active" 
          description={<Switch defaultSelected={notification.active} onValueChange={(value) => handleUpdateNotification(value)} />}
          icon={<SignalIcon />} 
        />
      </div>
    )}
  </div>
)

NotificationDetails.propTypes = {
  handleUpdateNotification: PropTypes.func.isRequired,
  notification: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    active: PropTypes.bool.isRequired,
  }).isRequired,
}

export default NotificationDetails